@import '../../style/index';

@include host {
  margin: 0;

  .overlay {
    @include layer-highest-priority-top;

    display: none;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgb(0 0 0 / 40%);
    align-items: center;
    justify-content: center;

    &.open {
      display: flex;
    }

    &.top {
      align-items: flex-start;
      justify-content: center;
      padding-top: rem-calc(40px);
    }

    &.bottom {
      align-items: flex-end;
    }

    &.with-search {
      @include layer-highest-priority-top;

      top: rem-calc(154px);
      padding-bottom: rem-calc(154px);

      @include large-up {
        top: rem-calc(188px);
        padding-bottom: rem-calc(188px);
      }

      @include xlarge-up {
        top: rem-calc(290px);
        padding-bottom: rem-calc(290px);
      }
    }
  }

  .modal-window {
    position: relative;
    max-height: var(--modal-scroll-max-height, rem-calc(700px));

    &.fullscreen {
      width: 100%;
      height: 100%;
      max-width: unset;
      max-height: unset;
    }

    @include shadow-sm();
  }

  .modal-window__scroll-container {
    width: 100%;
    max-height: var(--modal-scroll-max-height, auto) !important;
    overflow-y: auto;
  }

  .modal-window__content {
    width: 100%;
    height: 100%;

    &.with-padding {
      padding: rem-calc(64px);
    }
  }

  .close {
    cursor: pointer;
    position: absolute;
    right: rem-calc(4.8px);
    top: rem-calc(-24px);

    @include medium-up {
      right: rem-calc(-24px);
    }

    @include layer-highest-priority-top;
  }
}

@media (max-width: 599px) {
  // Institutional Consent Modal
  :host(.institutional-user-consent-modal) .overlay {
    align-items: flex-end !important;
  }

  :host(.institutional-user-consent-modal) .modal-window {
    height: auto !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin-top: rem-calc(40px);
    box-sizing: border-box;
  }

  :host(.institutional-user-consent-modal) .modal-window__scroll-container {
    box-sizing: border-box;
  }

  // Retail Consent Modal
  :host(.retail-user-consent-modal) .modal-window {
    height: auto !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin-top: rem-calc(40px);
    box-sizing: border-box;
  }

  :host(.retail-user-consent-modal) .overlay {
    align-items: flex-end !important;
  }

  :host(.retail-user-consent-modal) .modal-window__scroll-container {
    box-sizing: border-box;
  }
}
